<template>
  <div>
    <vx-card title="Тарифы" class="p-6">
      <vs-input
        @change="updateTariff(tariffs.find((x) => x.kind == 'T1').id)"
        class="w-full mb-8"
        label-placeholder="Электричество T1, руб"
        v-model.number="tariffs.find((x) => x.kind == 'T1').price"
      />
      <vs-input
        @change="updateTariff(tariffs.find((x) => x.kind == 'T2').id)"
        class="w-full mb-8"
        label-placeholder="Электричество T2, руб"
        v-model.number="tariffs.find((x) => x.kind == 'T2').price"
      />
      <vs-input
        @change="updateTariff(tariffs.find((x) => x.kind == 'T3').id)"
        class="w-full mb-8"
        label-placeholder="Электричество T3, руб"
        v-model.number="tariffs.find((x) => x.kind == 'T3').price"
      />
      <vs-input
        @change="updateTariff(tariffs.find((x) => x.kind == 'cold_water').id)"
        class="w-full mb-8"
        label-placeholder="Холодная вода, руб"
        v-model.number="tariffs.find((x) => x.kind == 'cold_water').price"
      />
    </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";

export default {
  data: () => ({
    BASE_URL: API_URL,
    tariffs: [],
  }),
  components: {},
  watch: {},
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getTariffs() {
      this.$vs.loading();

      this.$load(async () => {
        let res = (await this.$api.tariffs.getIndicationTariffs()).data;

        this.tariffs = res;
        this.$vs.loading.close();
      });
    },
    updateTariff(idTariff) {
      this.$vs.loading();

      let tariff = this.tariffs.find((x) => x.id == idTariff);

      let payload = {
        kind: tariff.kind,
        price: tariff.price,
      };

      this.$load(async () => {
        let res = (
          await this.$api.tariffs.updatePriceIndication(idTariff, payload)
        ).data;

        this.notification("Успешно", "Цена обновлена", "success");
        this.$vs.loading.close();
      });
    },
  },
  mounted() {
    this.getTariffs();
  },
};
</script>